import EditableField from "../common/EditableField";

function GuestDetailItem({ label, value, isEditing, className }) {
  return (
    <div className={className}>
      <p className="text-sm text-gray-500">{label}</p>
      <p className="text-lg text-gray-800">{String(value) || "-"}</p>
    </div>
  );
}

export default GuestDetailItem;
